import DateCellRenderer from '../../shared/agGrid/cellRenderers/dateCellRenderer.component';
import ErrorFlagCellRenderer from './errorFlagCellRenderer.component';

export const columnDefinitions = [
  { field: 'schemaName', headerName: 'Schema', minWidth: 140 },
  { field: 'jobId', headerName: 'Job ID', minWidth: 100 },
  { field: 'connName', headerName: 'Connection', minWidth: 140 },
  { field: 'periodName', headerName: 'Period', minWidth: 100 },
  { field: 'subject', headerName: 'Subject', minWidth: 240 },
  { field: 'createdOn', headerName: 'Created On', cellRenderer: DateCellRenderer, minWidth: 160 },
  {
    field: 'errorMsgFlag',
    headerName: 'Error Flag',
    cellRenderer: ErrorFlagCellRenderer,
    minWidth: 120,
  },
  { field: 'statusId', headerName: 'Status', minWidth: 90 },
  { field: 'body', headerName: 'Body', minWidth: 320 },
];
